import React, { useEffect, useRef } from 'react';
import { Table, Flex } from 'onefaceui-react-components';
import { useDispatch } from 'react-redux';

import { actionCreators } from 'react/api/actions/modals';

import { getResourceTo } from 'react/utils/utils';
import { DefaultRequest } from 'scripts/api';

import EditIcon from 'static/images/monet/edit.svg';
import { fields } from './utils/fields';
import { DataImportModal } from './DataImportModal';

import {
  Container, Description, Header, Title
} from './styles';

function DataImportSftp() {
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const getTableData = () => {
    const criteria = {
      filters: ['*'],
      firstResult: 0,
      maxResults: 51
    };

    const url = `/ExternalStorage/restrictions?criteria=${JSON.stringify(criteria)}`;

    tableRef.current.setLoading(true);

    new DefaultRequest({
      method: 'POST',
      url,
      success: (response) => {
        tableRef.current.setData(response);
        tableRef.current.setLoading(false);
      },
      error: () => {
        tableRef.current.setLoading(false);
      },
      data: { criteriaChain: [{}] }
    }).send();
  };

  const deleteData = (idsList) => {
    tableRef.current.setLoading(true);

    new DefaultRequest({
      method: 'POST',
      url: '/ExternalStorage/BatchDelete',
      success: () => {
        const data = tableRef.current.getData();
        const newDataTable = data.filter((d) => !idsList.includes(d.id));
        tableRef.current.setData(newDataTable);
        tableRef.current.setLoading(false);
      },
      error: () => tableRef.current.setLoading(false),
      data: idsList
    }).send();
  };

  const handleClickDelete = (values) => {
    const idsList = values.map(({ id }) => id);
    new Greenmile.Components.AlertModal(
      'Greenmile.Grid.BatchDelete.confirmDeletion',
      'Greenmile.Grid.BatchDelete.confirmDeletion.header',
      () => deleteData(idsList),
      null,
      {
        isADeleteAction: true
      }
    ).show();
  };

  const tableColumns = fields.map(({ label, name }) => ({
    title: getResourceTo(label),
    field: name
  }));

  useEffect(() => {
    getTableData();
  }, []);

  return (
    <Container>
      <Header>
        <Title>{getResourceTo('externalstorage.sftp.title')}</Title>
        <Description>{getResourceTo('externalstorage.sftp.description')}</Description>
      </Header>
      <Flex style={{ height: 400 }}>
        <Table
          ref={tableRef}
          headerOptions={{
            showResults: true,
            actions: {
              delete(values) {
                if (values.length) {
                  handleClickDelete(values);
                }
              },
              create() {
                dispatch(actionCreators.openModal({
                  modalKey: 'externalStorage',
                  title: getResourceTo('externalstorage.sftp.modal.new.title'),
                  data: {}
                }));
              },
              customizeColumns: true
            }
          }}
          customColumns={[{
            width: 50,
            field: 'edit',
            frozen: true,
            headerSort: false,
            hozAlign: 'center',
            formatter() {
              return `<img src=${EditIcon} alt="Edit Icon" />`;
            },
            cellClick(_, cell) {
              const {
                id, ftpHost, ftpUser, ftpPass, ftpPort, ftpType, name
              } = cell.getRow().getData();

              dispatch(actionCreators.openModal({
                modalKey: 'externalStorage',
                title: getResourceTo('externalstorage.sftp.modal.edit.title'),
                data: {
                  id, ftpHost, ftpUser, ftpPass, ftpPort, ftpType, name
                }
              }));
            }
          }]}
          columns={tableColumns}
        />
      </Flex>
      <DataImportModal getTableData={getTableData} />
    </Container>
  );
}

export default DataImportSftp;
